module.exports = __webpack_public_path__ + "img/western-union.2b656455.png";